import { TRANSLATIONS_SEED } from "../config/translations.seed";
import { translationApi } from "../helper/translations";

export async function migrateTranslationsFromSeed(limit?: number) {
  const results = {
    migrated: 0,
    updated: 0,
    failed: 0,
  };

  const existingTranslations = await translationApi.getAll();
  const existingMap = new Map(
    existingTranslations.map((t) => [`${t.key}_${t.module ?? "null"}`, t]),
  );

  const itemsToMigrate = TRANSLATIONS_SEED.slice(0, limit);

  for (const item of itemsToMigrate) {
    try {
      const mapKey = `${item.key}_${item.module ?? "null"}`;
      const existing = existingMap.get(mapKey);

      const translationData = {
        key: item.key,
        module: item.module ?? null,
        english: item.values.en ?? "",
        russian: item.values.ru ?? item.values.en ?? "",
        ukrainian: item.values.uk ?? item.values.en ?? "",
      };

      if (existing) {
        await translationApi.update(existing.id, translationData);
        results.updated++;
      } else {
        await translationApi.create(translationData);
        results.migrated++;
      }
    } catch (error) {
      console.error(`Failed to migrate translation: ${item.key}`, error);
      results.failed++;
    }
  }

  return results;
}
